import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-request-grid',
  templateUrl: './request-grid.component.html',
  styleUrls: ['./request-grid.component.css']
})
export class RequestGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/recovery/request/request-grid/request-grid.component.ts